import {
  axios_nomination,
} from '@/plugins/axios';

import configuration from '@/configurations';

class TaskRepository {

  /**
   * @param {Array} task_id_list
   * @returns {Promise}
   */
  async getTasks(task_id_list) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/task/tasks`,
      {
        params: task_id_list,
      }
    );

    return result.data;
  }

  /**
   * @returns {Promise}
   */
  async getTaskTypes() {
    const result = await axios_nomination.get(
      `${configuration.api_host}/v1/task/tasks/types`
    );

    return result.data;
  }

  /**
   * @param {Object} input
   * @param {String} input.name
   * @param {Number} input.user_id
   * @returns {Promise}
   */
  async createTaskType(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/task/tasks/types`,
      input
    );

    return result.data;
  }

  /**
   * @param {Number} task_type_id
   * @param {Object} input
   * @returns {Promise}
   */
  async updateTaskType(task_type_id, input) {
    const result = await axios_nomination.patch(
      `${configuration.api_host}/v1/task/tasks/types/${task_type_id}`,
      input
    );

    return result.data;
  }

  /**
   * @param {Number} task_type_id
   * @returns {Promise}
   */
  async deleteTaskType(task_type_id) {
    const result = await axios_nomination.delete(
      `${configuration.api_host}/v1/task/tasks/types/${task_type_id}`
    );

    return result.data;
  }

  /**
   * @param {Object} input
   * @returns {Promise}
   */
  async createTask(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/task/tasks`,
      input
    );

    return result.data;
  }

  /**
   * @param {Object} input
   * @returns {Promise}
   */
  async bulkCreateTasks(input) {
    const result = await axios_nomination.post(
      `${configuration.api_host}/v1/task/tasks/bulk-create`,
      input
    );

    return result.data;
  }

  /**
   * @param {Number} task_id
   * @param {Object} input
   * @returns {Promise}
   */
  async updateTask(task_id, input) {
    const result = await axios_nomination.patch(
      `${configuration.api_host}/v1/task/tasks/${task_id}`,
      input
    );

    return result.data;
  }
}

const task_repository = new TaskRepository();

export {
  task_repository,
};
